<template>
  <NuxtLayout>
    <div>
      <NuxtLoadingIndicator color="#2F4A5F" />
      <NuxtPage />
    </div>
  </NuxtLayout>
</template>
